export default __webpack_public_path__ + "static/media/delete-icon.654d87e9.svg";